import React, { useState } from 'react';
import classNames from 'classnames';
import './UiVerticalTabs.scss';

interface VerticalTabProps {
    title: string;
    noPadding?: boolean;
    children?: React.ReactNode;
}

const VerticalTab = ({ children }: VerticalTabProps) => <>{children}</>;

interface UiVerticalTabsProps {
    children: React.ReactElement<VerticalTabProps> | React.ReactElement<VerticalTabProps>[];
}

const UiVerticalTabs = ({ children }: UiVerticalTabsProps) => {
    const [activeTab, setActiveTab] = useState(0);
    const tabs = React.Children.toArray(children) as React.ReactElement<VerticalTabProps>[];

    const activeNoPadding = tabs[activeTab]?.props?.noPadding;

    return (
        <div className="ui-vtabs">
            <nav className="ui-vtabs-nav">
                {tabs.map((tab, index) => (
                    <div
                        key={index}
                        className={classNames('ui-vtabs-nav-item', { active: index === activeTab })}
                        onClick={() => setActiveTab(index)}
                    >
                        {tab.props.title}
                    </div>
                ))}
            </nav>
            <div className={classNames('ui-vtabs-content', { 'ui-vtabs-content--no-padding': activeNoPadding })}>
                {tabs[activeTab]}
            </div>
        </div>
    );
};

export { UiVerticalTabs, VerticalTab };
